

export enum ShareType {
    Story = 1,
    PhotoContestInvitation = 2,
    Website = 3
}